// extracted by mini-css-extract-plugin
export default {"header":"App_header__kUONd","link":"App_link__T1emW","button":"App_button__E4zDx","subLink":"App_subLink__xlZSx","dropdownFooter":"App_dropdownFooter__A-Qpd"};